import { getBillingMethods } from '@/resources/billingMethods';

const GET_BILLING_METHODS = 'GET_BILLING_METHODS';

const mutations = {
  [GET_BILLING_METHODS](state, result) {
    state.billingMethods = result;
  },
};

const actions = {
  async fetchBillingMethods({ commit }) {
    const response = await getBillingMethods();
    if (response.status !== 200) return Promise.reject(response.data);
    return commit(GET_BILLING_METHODS, response.data.data);
  },
};

const state = {
  billingMethods: [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
